import OrderSyncAndPayModal from './OrderSyncAndPayModal'

export default OrderSyncAndPayModal
